import React, { useState, useLayoutEffect, useContext } from 'react';

import * as S from './styles';
import SimpleInput from 'components/SimpleInput';
import InputImgBigger from 'components/InputImgBigger';
import SelectInput from 'components/SelectInput';
import { optionsRedirectType } from 'utils/optionsInputs';
import { generateUid } from 'utils/functions';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import DynamicPageContext from 'context/DynamicPage';
import { verifyIfFormCanSave, returListOptionsDynamicPage } from './functions';

export interface DataFormProps {
	padding: number;
	title: string;
	rne: string;
	banner: {
		title: string;
		image: {
			id: string;
			relativePath: string;
		};
		redirect: {
			type: string;
			value: string;
		};
	};
	query: string;
}

const initialData: DataFormProps = {
	title: '',
	rne: '',
	padding: 0,
	banner: {
		title: '',
		image: {
			id: '',
			relativePath: ''
		},
		redirect: {
			type: '',
			value: ''
		}
	},
	query: ''
};

export default function InputsSingleBanner() {
	const {
		dynamicPagesList,
		moduleInSavingMode,
		setModuleInSavingMode,
		setCanSaveModuleOnBack,
		setMessageErrorForm,
		setModuleOnPhoneToEdit,
		moduleOnPhoneToEdit
	} = useContext(DynamicPageContext);

	const [dataForm, setDataForm] = useState(initialData);
	const [optionsDynamicScreen, setOptionsDynamicScreen] = useState<
		SelectInputItemProps[]
	>([]);

	function findeOptionOnListByNumber(
		value: string,
		list: SelectInputItemProps[]
	) {
		const itemsList = list.filter((item) => item.id === value);
		if (itemsList.length > 0) {
			return itemsList[0];
		}

		return '';
	}

	useLayoutEffect(() => {
		//se esta criando um novo componente
		if (moduleInSavingMode !== null) {
			setModuleInSavingMode((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		} else {
			//se esta editando um componente
			setModuleOnPhoneToEdit((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		}

		verifyIfFormCanSave(dataForm, setCanSaveModuleOnBack, setMessageErrorForm);
	}, [dataForm]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
			setTimeout(() => {
				setDataForm((obj) => ({ ...obj, ...moduleOnPhoneToEdit.data }));
			}, 100);
		}
	}, []);

	//cria lista de opções de pagínas dinamicas em um estado para evitar reenderização
	useLayoutEffect(() => {
		setOptionsDynamicScreen(returListOptionsDynamicPage(dynamicPagesList));
	}, []);

	return (
		<S.container>
			<SimpleInput
				label="Título *"
				initialValue={dataForm.title}
				getValue={(value: string) => {
					setDataForm((obj) => ({ ...obj, title: value }));
				}}
			/>

			<S.twoInputs>
				<SimpleInput
					label="Query"
					initialValue={dataForm.query}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, query: value }));
					}}
				/>

				<SimpleInput
					paddingInLineEnd
					typeInput="number"
					label="Padding"
					initialValue={isNaN(dataForm.padding) ? '' : dataForm.padding}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, padding: parseInt(value) }));
					}}
				/>
			</S.twoInputs>

			<S.twoInputs>
				<SelectInput
					list={optionsRedirectType}
					getValue={(value: SelectInputItemProps | '') => {
						setDataForm((obj) => ({
							...obj,
							banner: {
								...obj.banner,
								redirect: {
									...obj.banner.redirect,
									type: value === '' ? value : (value?.id as string)
								}
							}
						}));
					}}
					initialValue={
						dataForm.banner.redirect.type === ''
							? ''
							: findeOptionOnListByNumber(
									dataForm.banner.redirect.type || '',
									optionsRedirectType
								)
					}
					label="Tipo de redirecionamento *"
				/>

				{(dataForm.banner.redirect.type === '' ||
					dataForm.banner.redirect.type === 'product' ||
					dataForm.banner.redirect.type === 'url' ||
					dataForm.banner.redirect.type === 'webview' ||
					dataForm.banner.redirect.type === 'query' ||
					dataForm.banner.redirect.type === 'screen_app') && (
					<SimpleInput
						label="Valor do redirecionamento *"
						initialValue={dataForm.banner.redirect.value}
						getValue={(value: string) => {
							setDataForm((obj) => ({
								...obj,
								banner: {
									...obj.banner,
									redirect: {
										...obj.banner.redirect,
										value: value
									}
								}
							}));
						}}
					/>
				)}

				{dataForm.banner.redirect.type === 'app_screen' && (
					<SelectInput
						list={optionsDynamicScreen}
						getValue={(value: SelectInputItemProps | '') => {
							setDataForm((obj) => ({
								...obj,
								banner: {
									...obj.banner,
									redirect: {
										...obj.banner.redirect,
										value: value === '' ? value : (value?.id as string)
									}
								}
							}));
						}}
						initialValue={
							dataForm.banner.redirect.value === ''
								? ''
								: findeOptionOnListByNumber(
										dataForm.banner.redirect.value || '',
										optionsDynamicScreen
									)
						}
						label="Valor redirecionamento *"
					/>
				)}
			</S.twoInputs>

			<S.twoInputs>
				<SimpleInput
					label="Título do banner *"
					initialValue={dataForm.banner.title}
					getValue={(value: string) => {
						setDataForm((obj) => ({
							...obj,
							banner: {
								...obj.banner,
								title: value
							}
						}));
					}}
				/>
				<SimpleInput
					label="RNE"
					initialValue={dataForm.rne}
					getValue={(value: string) => {
						setDataForm((obj) => ({
							...obj,
							rne: value
						}));
					}}
				/>
			</S.twoInputs>

			<InputImgBigger
				imgHeight={200}
				label="Banner"
				idImagem="InputsSingleBanner"
				initialImage={
					dataForm.banner.image.relativePath === ''
						? ''
						: `${dataForm.banner.image.relativePath}`
				}
				getImage={(value: any) => {
					setDataForm((obj) => {
						return {
							...obj,
							banner: {
								...obj.banner,
								image: {
									id: value?.id || generateUid(),
									relativePath: value?.url || value?.relativePath || ''
								}
							}
						};
					});
				}}
			/>
		</S.container>
	);
}
